import React, { useState } from "react";
import styled from "@emotion/styled";
import { Link } from "react-router-dom";

import FormHelper from "../../utils/FormHelper";
import Form from "../../components/LoginBox/Form";
import FormBox from "../../components/LoginBox/FormBox";
import { FaArrowRight } from "react-icons/fa6";
import { BREAKPOINTS } from "../../utils/consts";
import StyledLink from "../Molecules/StyledLink";

const SignUpBox = (props) => {
  const { navigate, location, dataHelper, userHelper, message, config } = props;

  const [loading, setLoading] = useState(0);

  const values = {
    FirstName: location?.state?.firstName,
    LastName: location?.state?.lastName,
    Email: location?.state?.email,
    CPF__c: location?.state?.cpf,
    LoyaltyBirthdate__c: location?.state?.birthdate,
  };

  const inputs = Signupform(props, values);

  const handleSignUp = async (formData) => {
    let username = formData["Email"];

    if (location?.location?.state?.socialData) {
      formData["socialData"] = location?.state?.socialData;
    }

    if (location?.location?.state?.socialType) {
      formData["socialType"] = location?.state?.socialType;
    }

    let response = await userHelper.checkUserExists({ username }, "signup");

    if (response?.success && response?.code) {
      switch (response.code) {
        case "user-exists":
          inputs.Email.focusError("Este usuário já está em uso");
          break;
        // case "user-needs-password-definition":
        //   return {
        //     success: true,
        //     redirect: [
        //       routes.accessCode.path,
        //       { UserFirebaseId: response.UserFirebaseId },
        //     ],
        //   };
        //   break;
        case "user-does-not-exist":
          return {
            success: true,
            redirect: ["/cadastro/senha", { state: formData }],
          };
        default:
          break;
      }
    } else {
      message.add({
        type: "error",
        message:
          "Não foi possível processar sua requisição. Por favor, tente novamente mais tarde.",
      });
    }
  };

  return (
    <StyledSignUpBox>
      <FormBox
        {...props}
        title="Cadastro"
        description="Digite seus dados abaixo:"
        config={config}
        inside={
          <>
            <Form
              navigate={navigate}
              location={location}
              dataHelper={dataHelper}
              config={config}
              inputs={inputs}
              handleSend={handleSignUp}
              loading={loading}
              setLoading={setLoading}
              sendLabel="Próxima"
            />
          </>
        }
      />
      <div className="sign-in">
        <span className="already-account">Já possui uma conta?</span>
        <StyledLink to={"/login"} config={config}>
          FAÇA SEU LOGIN
          <FaArrowRight />
        </StyledLink>
      </div>
    </StyledSignUpBox>
  );
};

export default SignUpBox;

/* form */

const Signupform = (props, startValues) => {
  return {
    FirstName: FormHelper.useFormInput({
      id: "firstName",
      label: "Nome",
      type: "text",
      validations: [
        {
          type: "required",
          errorMessage: "Digite seu nome",
        },
        {
          type: "personName",
          errorMessage:
            "O nome deve ser formado por letras. Mínimo 2 caracteres.",
        },
      ],
      inputOptions: {
        spellCheck: false,
        maxLength: 40,
      },
      startValue: startValues?.FirstName,
    }),
    LastName: FormHelper.useFormInput({
      id: "lastName",
      label: "Sobrenome",
      type: "text",
      validations: [
        {
          type: "required",
          errorMessage: "Digite seu sobrenome",
        },
        {
          type: "personName",
          errorMessage:
            "O sobrenome deve ser formado por letras. Mínimo 2 caracteres.",
        },
      ],
      inputOptions: {
        spellCheck: false,
        maxLength: 60,
      },
      startValue: startValues?.LastName,
    }),
    Email: FormHelper.useFormInput({
      id: "email",
      label: "E-mail",
      type: "text",
      validations: [
        {
          type: "required",
          errorMessage: "Digite um e-mail",
        },
        {
          type: "email",
          errorMessage: "Digite um endereço de e-mail válido",
        },
        {
          type: "custom",
          errorMessage: "Este e-mail já está em uso",
          customFunction: async (formInput, validation, aInputs) => {
            return !(await props.userHelper.authEmailExists(
              formInput.getValue()
            ));
          },
        },
      ],
      inputOptions: {
        spellCheck: false,
      },
      mask: "email",
      startValue: startValues?.Email,
    }),
    CPF__c: FormHelper.useFormInput({
      id: "cpf",
      label: "CPF",
      type: "text",
      validations: [
        // {
        //   type: "required",
        //   errorMessage: "Digite seu CPF",
        // },
        {
          type: "cpf",
          errorMessage:
            "Digite um CPF válido",
        },
      ],
      inputOptions: {
        inputMode: "numeric",
        spellCheck: false,
      },
      mask: "cpf",
      maskOptions: ["cpf"],
      startValue: startValues?.CPF__c,
    }),
    LoyaltyBirthdate__c: FormHelper.useFormInput({
      id: "birthdate",
      label: "Data de nascimento",
      type: "text",
      mask: "date",
      // validations: [
      //   {
      //     type: "required",
      //     errorMessage: "Digite a data de nascimento",
      //   },
      // ],
      inputOptions: {
        spellCheck: false,
        inputMode: "numeric",
      },
      append: <span style={{ color: "rgba(0, 59, 33, 1)" }}>DD/MM/AAAA</span>,
      startValue: startValues?.LoyaltyBirthdate__c,
    }),
    LoyaltyPhone__c: FormHelper.useFormInput({
      id: "phone",
      label: "Telefone",
      type: "text",
      inputOptions: {
        inputMode: "numeric",
        spellCheck: false,
      },
      validations: [
        // {
        //   type: "required",
        //   errorMessage: "Digite seu número de telefone",
        // },
        {
          type: "phone",
          errorMessage: "Digite um número de telefone válido",
        },
      ],
      mask: "phone",
      startValue: startValues?.LoyaltyPhone__c,
    }),
    ReferedCode__c: FormHelper.useFormInput({
      id: "referedCode",
      label: "Código de indicação",
      type: "text",
      inputOptions: {
        spellCheck: false,
        maxLength: 12,
      },
      startValue: startValues?.ReferedCode__c,
    }),
  };
};

/* styles */

const StyledSignUpBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 48px;
  align-items: center;
  margin-top: 42px;
  height: 100%;

  @media (max-width: ${BREAKPOINTS.PHONE}px) {
    gap: 24px;
  }

  .sign-in {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 16px;

    .already-account {
      font-family: "Roboto";
      font-size: 18px;
      line-height: 28px;
      font-weight: 400;
      color: #8c8c8c;
    }
  }
`;
